import ApolloClient from 'apollo-boost/lib/index';

import { getApiBase, authHeaders }  from 'utils/api/api';
import { applyShowArchived } from 'utils/graphqlIncludeArchived';

const uri = `${ getApiBase() }/graphql`;


export default new ApolloClient({ uri,
  request: async (operation) => {
    operation.setContext({
      headers: authHeaders()
    });
    // FIN-1211: reveal archived companies/vessels in selects when the global toggle is on.
    applyShowArchived(operation);
  }
});
